export default {
    ui: {
        not_selected: 'Nicht ausgewählt',
        no_result: 'Keine Ergebnisse',
        search_placeholder: 'Suchen...',
        vtagging_create: (tag) => `Neuen Tag "${tag}" hinzufügen`,
        upload_button: 'Datei hochladen',
        upload_delete: 'Löschen',
        upload_formats: 'Erlaubte Dateien',
        'upload_formats_image/png': 'PNG',
        'upload_formats_image/jpg': 'JPG',
        'upload_formats_application/pdf': 'PDF',
        'upload_formats_application/msword': 'DOC',
        'upload_formats_application/msexcel': 'XLS',
        'upload_formats_application/vnd.ms-powerpoint': 'PPT',
        'upload_formats_application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'DOCX',
        'upload_formats_application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'XLSX',
        'upload_formats_application/vnd.openxmlformats-officedocument.presentationml.presentation': 'PPTX',
        'upload_formats_image/jpeg': 'JPEG',
        'upload_formats_video/mpeg': 'MPEG',
        'upload_formats_video/mp4': 'MP4',
        'upload_formats_video/x-msvideo': 'AVI',
        upload_max_size: maxSize => `max. ${maxSize}MB`,
        upload_limit: limit => `max. ${limit} Dateien`,
        vtable_no_data: 'Keine Ergebnisse',
        lazy_loading_placeholder: 'Gib einen Suchbegriff mit mindestens 3 Zeichen ein um auswählbare Daten anzuzeigen.',
    },
    form: {
        cancel: 'Abbrechen',
        save: 'Speichern',
        submit: 'Absenden',
        submit_saving: 'Speichert',
        submit_success: 'Gespeichert!',
        discard: 'Nicht Speichern',
        unsaved_title: 'Ungespeicherte Änderungen',
        unsaved_body: 'Sie haben ungespeicherte Änderungen. Wollen sie speichern bevor Sie die Seite verlassen?',
    },
    validation: {
        required: 'Dieses Feld ist ein Pflichtfeld.',
        numeric: 'Geben Sie eine Zahl ein.',
        email: 'Geben Sie eine E-Mail Adresse ein.',
        default: 'Die Eingabe ist nicht valide.',
    },
    modal: {
        ok: 'Ok',
        confirm: 'Bestätigen',
        cancel: 'Abbrechen',
        confirm_title: 'Bestätigen',
        confirm_text: 'Bist du sicher?',
        error_title: 'Fehler',
        error_text: 'Ein unbekannter Fehler ist aufgetreten. Bitte versuchen sie es später erneut.',
    },
};